var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"comp-tab"},[_c('comp-tab-left',{attrs:{"isActived":_vm.selectedTab == 'friend'},on:{"tabClicked":function (value) { return _vm.updateSelectedTab(value); }}}),_vm._v(" "),_c('comp-tab-right',{attrs:{"isActived":_vm.selectedTab == 'group'},on:{"tabClicked":function (value) { return _vm.updateSelectedTab(value); }}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ab71815","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompTab.vue
// module id = null
// module chunks = 